
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Component Libraries`}</h3>
    <ul>
      <li parentName="ul">{`Added a `}<a parentName="li" {...{
          "href": "https://pxblue-components.github.io/angular/?path=/info/components-mobile-stepper--readme"
        }}>{`Mobile Stepper`}</a>{` component for Angular`}</li>
      <li parentName="ul">{`Angular components are now compatible with Angular 10+`}</li>
      <li parentName="ul">{`Updated React Native components to be compatible with `}<inlineCode parentName="li">{`react-native-paper`}</inlineCode>{` version 4`}</li>
    </ul>
    <h3>{`Design Patterns`}</h3>
    <ul>
      <li parentName="ul">{`Updated content for `}<a parentName="li" {...{
          "href": "/patterns/navigation"
        }}>{`Navigation`}</a>{` and `}<a parentName="li" {...{
          "href": "/patterns/visualizations"
        }}>{`Visualizations`}</a></li>
      <li parentName="ul">{`Released a new `}<a parentName="li" {...{
          "href": "https://www.figma.com/community/file/926189711301522231"
        }}>{`Design Pattern Sticker Sheet`}</a>{` that will include many examples of all of our `}<a parentName="li" {...{
          "href": "/patterns"
        }}>{`Design Patterns`}</a>{`, starting with `}<a parentName="li" {...{
          "href": "/patterns/forms"
        }}>{`forms`}</a>{`, `}<a parentName="li" {...{
          "href": "/patterns/overlay"
        }}>{`side sheet`}</a>{` and `}<a parentName="li" {...{
          "href": "/patterns/lists"
        }}>{`lists`}</a>{`.`}</li>
    </ul>
    <h3>{`Documentation Site`}</h3>
    <ul>
      <li parentName="ul">{`Updated `}<a parentName="li" {...{
          "href": "/style/iconography"
        }}>{`Iconography`}</a>{` page to enable users to download icons and search by keywords/tags`}</li>
      <li parentName="ul">{`Added a new page dedicated to helping you build a `}<a parentName="li" {...{
          "href": "/design/project-identity"
        }}>{`Project Identity`}</a></li>
      <li parentName="ul">{`Added new holiday themes`}</li>
    </ul>
    <h3>{`PX Blue CLI`}</h3>
    <ul>
      <li parentName="ul">{`You can now use `}<a parentName="li" {...{
          "href": "https://github.com/pxblue/react-cli-templates"
        }}>{`templates`}</a>{` to kick-start your React projects with navigation and authentication`}</li>
    </ul>
    <h3>{`Reusable Workflows`}</h3>
    <ul>
      <li parentName="ul">{`Reusable `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/package/@pxblue/angular-auth-workflow"
        }}>{`Authentication Workflow`}</a>{` for Angular.`}</li>
    </ul>
    <h3>{`Component Sticker Sheet`}</h3>
    <ul>
      <li parentName="ul">{`Re-built all the components using the new Figma variants and auto-layout`}</li>
      <li parentName="ul">{`Added images, tiles and patterns`}</li>
      <li parentName="ul">{`Added more components (badges, dialogs, form controls, icon buttons, menus, side sheets, steppers and toggle buttons)`}</li>
      <li parentName="ul">{`Reorganized the sticker sheet structure`}</li>
    </ul>
    <h3>{`Miscellaneous`}</h3>
    <ul>
      <li parentName="ul">{`Bug fixes & performance updates`}</li>
      <li parentName="ul">{`Addressed security vulnerabilities`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;